<template>

  <section class="padded">

    <el-row>
      <h3>Notification e-Mails for <b>this {{this.actionData.actionType}}</b></h3>
    </el-row>

    <el-alert type="info"
      title="Organisation Emails"
      :description="alertDescription"
      show-icon
      center
      :closable="false" />

    <el-row :gutter="12">
      <table class="el-table">
        <thead>
          <th><center>{{this.actionData.organisation.name}}
            <el-button v-if="(isTelco() || isSuper()) && canEditTelcoRecipients()" type="text"
              :aria-label="'Add missing ' + telcoOrgName() + ' contacts'"
              @click="updateEmails('telco', true)">
              <i class="fa fa-sync"></i>
            </el-button>
          </center>
        </th>
        <th>
          <center>{{this.xolasClient().name}}
            <el-button v-if="isTowerCo()" type="text"
              :aria-label="'Add missing ' + this.xolasClient().name + ' contacts'"
              @click="updateEmails('tower', true)">
              <i class="fa fa-sync"></i>
            </el-button>
          </center>
        </th>
      </thead>

      <!--
      <el-input v-if="isTelco()" v-model="email" type="text" size="small">
      <template #prepend><i class="fa fa-envelope"></i></template>
    </el-input>
    <span v-else>
    <b>{{email}}</b> <a v-if="email" :href="'mailto:' + email"><i class="fa fa-edit-outline"></i></a>
  </span>

-->
  <tbody>
    <tr>
      <td>
        <!-- XOL-526 (U-L): an empty per-request list now silently falls back
             to the org's own opt-ins server-side (A7) — say so, or the Tower
             Co has no way to know why an "empty" list still sends mail. -->
        <p v-if="!emails.telco || emails.telco.length === 0" class="text-muted"><small>{{emptyFallbackLine('telco')}}</small></p>
        <div v-for="(email, index) in emails.telco" :key="email.email || index">
          <el-col :span="18" :offset="2">
            <a v-if="email" :href="'mailto:' + email.email">
              <i class="fa fa-edit-outline"></i> {{email.email}}
            </a>
          </el-col>
          <el-col :span="4">
            <el-button v-if="canEditTelcoRecipients()"
            style="color: indianred;"
            :aria-label="'Remove ' + email.email"
            @click="deleteEmail(emails.telco, index)"
            type="text" size="mini">
            <i class="fa fa-times-circle"></i>
          </el-button>
        </el-col>
      </div>
    </td>
    <td>
      <p v-if="!emails.tower || emails.tower.length === 0" class="text-muted"><small>{{emptyFallbackLine('tower')}}</small></p>
      <div v-for="(email, index) in emails.tower" :key="email.email || index">
        <el-col :span="18" :offset="2">
          <a v-if="email" :href="'mailto:' + email.email">
            <i class="fa fa-edit-outline"></i> {{email.email}}
          </a>
        </el-col>
        <el-col :span="4">
          <el-button v-if="isTowerCo()"
          @click="deleteEmail(emails.tower, index)"
          :aria-label="'Remove ' + email.email"
          style="color: indianred;"
          type="text" size="mini">
          <i class="fa fa-times-circle"></i>
        </el-button>
      </el-col>
    </div>
  </td>
  </tr>

  <tr>
    <td>
      <div v-if="(isTelco() || isSuper()) && canEditTelcoRecipients()">
        <el-row>
          <el-col :span="16">
            <el-input type="email" v-model="newTelcoEmail" />
          </el-col>
          <el-col :span="4" :offset="1">
            <el-button type="primary"
            @click="addEmail('telco', newTelcoEmail)"
            :disabled="!newTelcoEmail">
            <i class="fa fa-plus"></i> Add</el-button>
          </el-col>
        </el-row>
      </div>
      <!-- XOL-535 (S6, UX §2.6.2): a Telco on RTS/RTU/RTD (D9 is RTB-only)
           sees why the controls above are gone, instead of a silently-empty
           cell. A VIEW-ONLY Telco on an RTB never reaches this render at all
           — Popup.vue disables its trigger for any view-only user
           (`:disabled="disableButton || isViewOnly()"`), so the popup itself
           never opens for them; this note is not what tells them anything. -->
      <p v-else-if="isTelco() || isSuper()" class="text-muted">
        <small>{{'Only ' + towerCoName() + ' can change this list.'}}</small>
      </p>
    </td>
    <td>
      <div v-if="isTowerCo()">
        <el-row>
          <el-col :span="16">
            <el-input type="email" v-model="newEmail" />
          </el-col>
          <el-col :span="4" :offset="1">
          <el-button type="primary"
            @click="addEmail('tower', newEmail)"
            :disabled="!newEmail">
            <i class="fa fa-plus"></i> Add</el-button>
          </el-col>
        </el-row>
      </div>
    </td>
  </tr>

  </tbody>

  <tfoot>
    <td>
      <el-col align="center">
      <el-button v-if="isTelco() || isSuper()"
      type="warning"
      icon="fa fa-envelope"
      @click="sendTest('telco')" :disabled="!isEnabled">Send Test Email</el-button>
    </el-col>
    </td>
    <td>
      <el-col align="center">
        <el-button v-if="isTowerCo()"
          type="warning"
          icon="fa fa-envelope"
          @click="sendTest('tower')" :disabled="!isEnabled">Send Test Email</el-button>

       </el-col>

       <div>
         <span class="text-muted">Configure: </span>
         <check-box v-model="emails.sendMail" :disabled="!isTowerCo() || isViewOnly()" no-form>
         Send E-mails
       </check-box>
     </div>


  </td>
  </tfoot>

</table>

<!-- XOL-526 (U-L): there is no third column for the provider (D10 ii) — say
     where its notices go, so a Tower Co managing recipients doesn't wonder
     why the provider isn't listed anywhere. -->
<p v-if="hasDistinctProvider()" class="text-muted">
  <small><i class="fa fa-info-circle" aria-hidden="true"></i> {{providerNoticeLine}}</small>
</p>
</el-row>


</section>

</template>


<script>

import RequestMixins from '@/mixins/RequestMixins'

export default {
  mixins: [RequestMixins],

  props: {

    rowData: {
      type: Object,
      required: true
    },

    rtxInfo: {
      type: Object,
      required: true
    }

  },


  methods: {
    sendTest (prop = this.isTelco() ? 'telco' : 'tower') {

      var verify = {
        info: this.rtxInfo.info,
        from: {
          email: this.xolasClient().email,
          name: this.xolasClient().name,
          logo: this.xolasClient().logoPath
        },
        sendTo: []
      }

      var i = 0

      for (i = 0; i < this.emails[prop].length; i++) {
        if (this.emails[prop][i].email) {
          verify.sendTo.push(this.emails[prop][i].email)
        }
      }

      this.send(this, this.getEndpoint('mail/verify'), verify, 'Verification e-Mail', this.sent, this.notSent)
    },


    sent (response) {
      this.$message({message: 'e-mail sent', type: 'success'})
    },


    notSent (response) {
      this.$message({message: 'e-mail failed to send', type: 'error'})
      console.error(response)
    },


    addEmail (prop, email) {
      var cont = {}
      cont.sendUploadAlerts = true
      cont.sendApprovalAlerts = true
      cont.email = email

      this.emails[prop].push(this.clone(cont))
      this.newEmail = null
      this.newTelcoEmail = null

      // XOL-535 (S6): the owner writes its own minimal PUT (P15-aware);
      // the Tower Co's full-record save is unchanged.
      //
      // Reviewer request-changes round 3 (2026-09-23): `addedEmails` is
      // `newTelcoAddresses()` (everything still unconfirmed against
      // `telcoBaseline`), NOT just `[email]` — otherwise a second save
      // issued before an EARLIER add's save returns can silently drop that
      // earlier address with no warning: the earlier save's response is
      // discarded as stale (it's no longer the latest `telcoSaveSeq`), and
      // the later save's own `addedEmails` (just `[email]`) would never have
      // named the earlier address, so nothing checks whether IT survived.
      // Recomputing the full "still new" set on every save means whichever
      // save's response actually applies checks every address that hasn't
      // yet been confirmed, not just the one that triggered this call.
      if (prop === 'telco' && !this.isTowerCo()) {
        if (this.canEditTelcoRecipients()) this.saveTelcoRecipients(this.newTelcoAddresses())
        return
      }

      if (this.canWriteStep()) {
        this.actionData.emails = this.emails
        this.saveRequest(this.actionData)
      }
    },


    deleteEmail (list, index) {
      var isTelcoList = (list === this.emails.telco)
      list.splice(index, 1)

      // XOL-535 (S6): same split as addEmail — the owner writes its own
      // minimal PUT; the Tower Co's full-record save is unchanged. Same
      // `newTelcoAddresses()` reasoning as addEmail above (round 3).
      if (isTelcoList && !this.isTowerCo()) {
        if (this.canEditTelcoRecipients()) this.saveTelcoRecipients(this.newTelcoAddresses())
        return
      }

      if (this.canWriteStep()) {
        this.actionData.emails = this.emails
        this.saveRequest(this.actionData)
      }
    },


    // XOL-535 (S6): the owner's minimal `emails.telco` write. `addedEmails`
    // is the list of NEW addresses THIS save is trying to add (used only to
    // detect a P15 server-side drop below) — the full current list AT THE
    // TIME OF THIS CALL is what's sent, since the API merges per-address and
    // keeps every already-stored entry as it is.
    //
    // Reviewer request-changes (2026-09-23), item 1: two races, both fixed
    // here rather than in the response handler alone —
    //   (a) a LOCAL edit made while this save is still in flight (e.g. the
    //       sync button pushes new entries with no immediate save of its
    //       own) must not be wiped when this save's response lands; the
    //       snapshot of what was actually SENT (`sentAddresses`) is what lets
    //       telcoRecipientsSaved() tell "sent, not stored" apart from
    //       "added locally after I was sent".
    //   (b) an OUT-OF-ORDER response (this save's request was slow, and a
    //       LATER save's response already landed) must be ignored outright —
    //       `telcoSaveSeq` is a monotonically increasing id of the most
    //       recently ISSUED save; a response only applies if it's still for
    //       that same save when it arrives.
    saveTelcoRecipients (addedEmails) {
      var self = this
      var sent = this.emails.telco.slice()
      var sentAddresses = sent.map(function (e) { return e && e.email }).filter(function (e) { return !!e })

      this.telcoSaveSeq += 1
      var seq = this.telcoSaveSeq

      this.saveOwnRequestFields({emails: {telco: sent}}, function (data) {
        self.telcoRecipientsSaved(data, addedEmails, sentAddresses, seq)
      })
    },


    // XOL-535 (API delta P15): a NEW address survives the owner's save only
    // if it's an enabled contact of the owner org — the response is still
    // 200 either way. Resync the local list from the true stored value, and
    // warn only about address(es) THIS save just tried to add that didn't
    // survive (already-stored entries are never dropped).
    telcoRecipientsSaved (data, addedEmails, sentAddresses, seq) {
      // (b) stale response: a newer save has already been issued since this
      // one — its own response (still pending or already applied) is
      // authoritative, so this one must change nothing.
      if (seq !== this.telcoSaveSeq) return

      var stored = (data && data.emails && data.emails.telco) ? data.emails.telco : this.emails.telco

      // (a) a local edit made while THIS save was in flight (its address
      // wasn't part of what was sent) survives the response, because the
      // server has never seen it and so can't have confirmed OR dropped it.
      var sent = sentAddresses || []
      var extras = (this.emails.telco || []).filter(function (e) {
        return e && e.email && sent.indexOf(e.email) === -1
      })

      this.emails.telco = stored.concat(extras)
      // telcoBaseline reflects only what the SERVER actually has — any
      // `extras` therefore stay dirty relative to it, so beforeDestroy's
      // close-time save still picks them up.
      this.telcoBaseline = this.clone(stored)

      var dropped = (addedEmails || []).filter(function (email) {
        return !stored.some(function (e) { return e && e.email === email })
      })

      if (dropped.length === 0) return

      var subject = dropped.length === 1 ? dropped[0] : dropped.join(', ')
      var verb = dropped.length === 1 ? 'was' : 'were'

      this.$notify({
        type: 'warning',
        title: 'Warning',
        message: subject + ' ' + verb + ' not added: only enabled ' + this.telcoOrgName() + ' contacts can receive these notices.'
      })
    },


    // XOL-535: which entries in the current emails.telco list are NEW
    // relative to telcoBaseline (the value at open, refreshed after every
    // immediate save) — drives beforeDestroy's dirty-save, which only needs
    // to catch a sync-button change (that mutates the list without an
    // immediate save; deletions always save immediately, so are never
    // "dirty" here).
    newTelcoAddresses () {
      var known = (this.telcoBaseline || []).map(function (e) { return e && e.email }).filter(function (e) { return !!e })
      return (this.emails.telco || [])
        .map(function (e) { return e && e.email })
        .filter(function (email) { return email && known.indexOf(email) === -1 })
    },


    // XOL-526/535 (U-L, §2.6.2): the telco column's org name, with the
    // established fallback for a malformed/partial actionData.
    telcoOrgName () {
      return (this.actionData.organisation && this.actionData.organisation.name) ? this.actionData.organisation.name : 'the telco'
    },


    updateEmails (type, addMissing = false) {

      this.updateEmailList(this.emails[type],
      (type === 'tower'
      ? this.tower
      : this.telco),
      addMissing)

    },


    updateTowerEmails (data) {
      this.tower = data
//      console.log('tower', this.tower)
    },


    updateTelcoEmails (data) {
      this.telco = data
//      console.log('telco', this.telco)
    },

    // XOL-526 (U-L): explains the fallback A7 now applies server-side to an
    // empty per-request list.
    emptyFallbackLine (prop) {
      var orgName = prop === 'telco' ? this.telcoOrgName() : this.towerCoName()

      return 'No one is listed, so upload notices go to ' + orgName + ' users who have Upload Alerts on in their User Profile.'
    }

  },

  computed: {

    // XOL-526 (U-L): D10(ii) — the provider is never a column here; its
    // people opt in on their own profile.
    providerNoticeLine: function () {
      return 'Upload notices also go to ' + this.providerLabel() +
        '. Its users choose whether to receive them with Upload Alerts on their own User Profile, so they are not listed here.'
    },

    // XOL-535 (S6, UX §2.6.2): drops the "you can add" sentence for a viewer
    // who can't add to the telco list (a view-only Telco, or a Telco on a
    // non-RTB type). For the Tower Co, `canEditTelcoRecipients()` reduces to
    // `canWriteStep()` (`isTowerCo() && !isViewOnly()`) — so this is the
    // fuller text for a writable Tower Co, same as today, but the shorter
    // text for a view-only one, which could not add to either column anyway.
    alertDescription: function () {
      return this.canEditTelcoRecipients()
        ? 'The default emails are defined by the system administrator. You can add individual emails here.'
        : 'The default emails are defined by the system administrator.'
    },

    isEnabled: function () {
      var enabled = false

      var prop = this.isTelco() ? 'telco' : 'tower'

      for (var i = 0; i < this.emails[prop].length; i++) {
        if (this.emails[prop][i]) {
          enabled = true
          break
        }
      }  // for

      return enabled
    }

  },


  data () {
    return {
      newEmail: null,
      newTelcoEmail: null,
      emails: this.rowData.emails,
      actionData: this.rowData,
      telco: [],
      tower: [],
      siteId: this.rowData ? this.rowData.site_id : null,
      // XOL-535 (S6): the owner's dirty-on-close baseline for emails.telco —
      // set for real in created(), and refreshed after every immediate save
      // (addEmail/deleteEmail), so only a sync-button change (which mutates
      // the list without saving) leaves beforeDestroy something to send.
      telcoBaseline: [],
      // XOL-535 (reviewer request-changes item 1): a monotonically
      // increasing id of the most recently ISSUED emails.telco save — lets
      // telcoRecipientsSaved() ignore an out-of-order (older) response.
      telcoSaveSeq: 0
    }

  },


  created () {
    // XOL-526 (C3): both fetches are cross-tenant reads (tenant.towerco) —
    // unguarded, they 403 for every caller that isn't the Tower Co or the
    // org being read. `showEmailSetup` (RequestWorkflow.vue) NARROWS who
    // even opens this popup — a provider never reaches it (D10 ii) — it
    // does not widen the caller set. The guard here is for the two callers
    // who already could open it: the Tower Co (always passes) and the Telco
    // owner, whose TOWER fetch was the actual C3 bug (it read the Tower Co's
    // contacts and 403'd every time).
    if (this.canReadOrgScoped(this.actionData.organisation_id)) {
      this.fetchData('/contacts/org/' + this.actionData.organisation_id + '/raw/true', this.updateTelcoEmails, 'Telco Contacts')
    }

    if (this.canReadOrgScoped(this.xolasClient().id)) {
      this.fetchData('/contacts/org/' + this.xolasClient().id + '/raw/true', this.updateTowerEmails, 'Tower Contacts')
    }

    // XOL-535 (S6): the dirty-on-close baseline (see the data() note above).
    this.telcoBaseline = this.emails && this.emails.telco ? this.clone(this.emails.telco) : []
  },


  beforeDestroy () {
    if (this.isTowerCo()) {
      if (!this.canWriteStep()) return
      this.actionData.emails = this.emails
      this.saveRequest(this.actionData)
      return
    }

    // XOL-535 (S6): add/delete already saved immediately — this only catches
    // a sync-button change left dirty at close, and only for the owner; a
    // provider never reaches this popup (D10 ii) and a read-only Telco has
    // no controls that could make emails.telco dirty in the first place.
    if (!this.canEditTelcoRecipients()) return

    var added = this.newTelcoAddresses()
    if (added.length === 0) return

    this.saveTelcoRecipients(added)
  }

}

</script>
